module.exports = __webpack_public_path__ + "img/stunt-pc.e07137a0.png";